import type { Language } from "@app/constants";

interface Messages {
	allowanceAvailable: string;
	balance: string;
	currencyCode: string;
	defaultPercent: string;
	defaultValue: string;
	footnote: string;
	minReturn: string;
	totalProfit: string;
	tradeStatus: string;
}

type Message = { [key in Language]: Messages };

const messages: Message = {
	en: {
		allowanceAvailable: "Allowance Available",
		balance: "Balance",
		currencyCode: "R ",
		defaultPercent: "0",
		defaultValue: "0",
		footnote: `Note that this is an <strong>approximate</strong> balance based on your recent trades. It may be inaccurate if you have recently deposited or withdrawn funds.`,
		minReturn: "Min Return",
		totalProfit: "Total Profit",
		tradeStatus: "Trade Status",
	},
};

export default messages;
